module.exports = __webpack_public_path__ + "img/skype-brands.ef0e264f.svg";